import axios, {AxiosResponse} from 'axios'
// import {SAMPLE} from './sampleResponse'
const API_URL = process.env.REACT_APP_THEME_API_URL

export interface PLReportResp {
  grossProfit: number | null
  grossLoss: number | null
  netProfit: number | null
  netLoss: number | null
  'Direct Expenses': DirectExpenses
  'Indirect Expenses': DirectExpenses
  'Direct Income': DirectExpenses
  'Indirect Income': DirectExpenses
}

export interface DirectExpenses {
  children: Ledger[]
  amount: number
  groupId?: number
}

export interface Ledger {
  parentLedger: string

  children?: subledger[] | null
  amount: number
  ledgerId: number | null
}
export interface subledger {
  subLedger?: string
  ledgerId?: number
  amount?: number
}
export interface PLReportParams {
  company_id: number
  fy_name: string
  from_date?: string
  to_date?: string
}

const transformResponse = function (res: any): PLReportResp {
  // console.log(res)
  return {
    grossProfit: res.gross_amount >= 0 ? res.gross_amount : null,
    grossLoss: res.gross_amount < 0 ? res.gross_amount : null,
    netProfit: res.net_amount >= 0 ? res.net_amount : null,
    netLoss: res.net_amount < 0 ? res.net_amount : null,
    'Direct Expenses': {
      children: res.direct_expense.children.map((child: any) => ({
        parentLedger: child.parent_ledger,
        subledger: null,
        ledgerId: child?.ledger_id || null,
        children: child?.children?.map(
          (subChild: any): subledger => ({
            subLedger: subChild?.sub_ledger,
            amount: subChild?.value,
            ledgerId: subChild?.ledger_id,
          })
        ),
        amount: child.value,
      })),
      groupId: res.direct_expense.group_id,
      amount: res.direct_expense.value,
    },
    'Indirect Expenses': {
      groupId: res.indirect_expense.group_id,
      children: res.indirect_expense.children.map((child: any) => ({
        parentLedger: child.parent_ledger,
        subledger: null,
        ledgerId: child?.ledger_id || null,
        children: child?.children?.map(
          (subChild: any): subledger => ({
            subLedger: subChild?.sub_ledger,
            amount: subChild?.value,
            ledgerId: subChild?.ledger_id,
          })
        ),
        amount: child.value,
      })),
      amount: res.indirect_expense.value,
    },
    'Direct Income': {
      groupId: res.direct_income.group_id,

      children: res.direct_income.children.map((child: any) => ({
        parentLedger: child.parent_ledger,
        subledger: null,
        ledgerId: child?.ledger_id || null,
        children: child?.children?.map(
          (subChild: any): subledger => ({
            subLedger: subChild?.sub_ledger,
            amount: subChild?.value,
            ledgerId: subChild?.ledger_id,
          })
        ),
        amount: child.value,
      })),
      amount: res.direct_income.value,
    },
    'Indirect Income': {
      groupId: res.indirect_income.group_id,
      children: res.indirect_income.children.map((child: any) => ({
        parentLedger: child.parent_ledger,
        subledger: null,
        ledgerId: child?.ledger_id || null,
        children: child?.children?.map(
          (subChild: any): subledger => ({
            subLedger: subChild?.sub_ledger,
            amount: subChild?.value,
            ledgerId: subChild?.ledger_id,
          })
        ),
        amount: child.value,
      })),
      amount: res.indirect_income.value,
    },
  }
}
export const getPLReport = async (params: PLReportParams): Promise<PLReportResp | undefined> => {
  try {
    const response = await axios.post(
      `${API_URL}/accounting/transaction/report/profit-loss/`,
      {
        ...params,
        report_name: 'pnl_report',
        report_type: null,
      },
      {
        validateStatus: () => true,
      }
    )
    if (!response) {
      throw new Error('Internal Server Error')
    }

    if (response.data && response.data.status && response.data.status === 'error') {
      throw new Error(response.data.message)
    }

    return transformResponse(response.data)
  } catch (err: any) {
    if (err) throw err
  }
}
